module.exports = "pegasus/assets/email1-column-11.png";